// Rule-based visit-time validation (no AI). Returns {block, warnings[]}.
export function validateVisitTime({ visitTime, sessionStart, existingVisits = [], contactId, maxBackdateMin = 720, t }) {
  const res = { block: null, warnings: [] };
  const now = Date.now();
  const vt = new Date(visitTime).getTime();

  // Future time -> hard block
  if (vt > now + 60 * 1000) { res.block = t("warn_future"); return res; }
  // Outside the visit date (today) -> hard block
  if (new Date(visitTime).toDateString() !== new Date().toDateString()) { res.block = t("warn_future"); return res; }

  // Before day start -> warning
  if (sessionStart && vt < new Date(sessionStart).getTime()) res.warnings.push(t("warn_before_start"));
  // Beyond admin-configured backdate -> warning
  if (maxBackdateMin && now - vt > maxBackdateMin * 60 * 1000) res.warnings.push(t("warn_backdate"));
  // Conflicting/near time with another visit (within 2 min) -> warning (does not block)
  const conflict = existingVisits.some((v) => {
    const t2 = new Date(v.visit_time || v.created_at).getTime();
    return Math.abs(t2 - vt) < 2 * 60 * 1000;
  });
  if (conflict) res.warnings.push(t("warn_conflict"));
  // Possible duplicate visit to same contact today -> warning
  if (contactId && existingVisits.some((v) => v.contact_id === contactId)) res.warnings.push(t("warn_duplicate"));

  return res;
}
